import React, { useState } from "react";
import { useLanguage } from "../../../../common/i18n/LanguageContext";

function Step1({
  isThaiTableVisible,
  rewardTypeGroups = [],
  payrateUpdate,
  setPayrateUpdate,
  commission,
  setCommission,
  handleChangeObj,
  handleChangepayrateObj,
}) {
  const { t } = useLanguage();
  // Groups where "ใช้ค่าเดียวกันทั้งกลุ่ม" is checked — every stake's reward
  // and commission in that group mirrors the group's first stake. While
  // checked, only the first stake's inputs stay editable; editing them
  // cascades the value to the rest of the group live.
  const [syncedGroupIds, setSyncedGroupIds] = useState({});

  const cascadeToGroup = (group, value, setState) => {
    const rewardTypes = group.rewardTypes || [];
    setState((prev) => {
      const next = { ...prev };
      rewardTypes.forEach((rt) => {
        next[rt.code] = value;
      });
      return next;
    });
  };

  const handleToggleSync = (group, checked) => {
    setSyncedGroupIds((prev) => ({ ...prev, [group.id]: checked }));
    if (!checked) return;
    const firstRt = (group.rewardTypes || [])[0];
    if (!firstRt) return;
    cascadeToGroup(group, payrateUpdate[firstRt.code] ?? 0, setPayrateUpdate);
    cascadeToGroup(group, commission[firstRt.code] ?? 0, setCommission);
  };

  const handleRewardChange = (e, group, rt) => {
    const isFirst = (group.rewardTypes || [])[0]?.id === rt.id;
    if (syncedGroupIds[group.id] && isFirst) {
      const value = Number(e.target.value) || 0;
      cascadeToGroup(group, value, setPayrateUpdate);
      return;
    }
    handleChangepayrateObj(e, payrateUpdate, setPayrateUpdate);
  };

  const handleCommissionChange = (e, group, rt) => {
    const isFirst = (group.rewardTypes || [])[0]?.id === rt.id;
    if (syncedGroupIds[group.id] && isFirst) {
      const value = Number(e.target.value) || 0;
      cascadeToGroup(group, value, setCommission);
      return;
    }
    handleChangeObj(e, commission, setCommission);
  };

  return (
    <div className="md:w-full h-auto flex p-2 flex-col space-y-2 bg-slate-200 rounded-lg">
      {rewardTypeGroups.length === 0 && (
        <div className="bg-white p-4 rounded-lg shadow-sm text-center text-slate-500">
          {t("member_commission_no_groups")}
        </div>
      )}

      {rewardTypeGroups.map((group) => {
        const firstRtId = (group.rewardTypes || [])[0]?.id;
        const synced = !!syncedGroupIds[group.id];
        return (
          <div
            key={group.id}
            className="w-full text-center justify p-1 rounded-sm bg-blue-400 hover:bg-blue-800"
          >
            <div className="flex items-center justify-center gap-2">
              <label className="flex items-center gap-1 text-white text-[15px] font-bold">
                <input
                  type="checkbox"
                  checked={synced}
                  onChange={(e) => handleToggleSync(group, e.target.checked)}
                />
                {t("member_commission_sync_group")}
              </label>
              <span className="text-white text-[15px] font-bold">
                {group.name}
              </span>
            </div>
            {isThaiTableVisible && (
              <div className="rounded overflow-hidden mt-1 bg-white p-2">
                {(group.rewardTypes || []).length === 0 && (
                  <span className="text-[12px] text-slate-400">
                    {t("commission_step_no_items")}
                  </span>
                )}
                <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-2">
                  {(group.rewardTypes || []).map((rt) => {
                    const isFirst = rt.id === firstRtId;
                    const fieldDisabled = synced && !isFirst;
                    return (
                      <div
                        key={rt.id}
                        className="border-[1px] border-slate-300 rounded-lg p-2"
                        title={`${rt.code} (${rt.stake}) — ${rt.exp}`}
                      >
                        <div className="font-bold text-[12px] text-center mb-1">
                          {rt.name}
                        </div>
                        <div className="flex flex-col gap-1">
                          <div className="flex items-center gap-1">
                            <label className="text-[11px] text-slate-500 w-[70px] text-left shrink-0">
                              {t("commission_step_reward_label")}
                            </label>
                            <input
                              type="number"
                              min="0"
                              disabled={fieldDisabled}
                              className="w-full font-bold text-[12px] border-[1px] border-slate-300 rounded-lg text-center disabled:bg-slate-100 disabled:text-slate-400"
                              name={rt.code}
                              value={payrateUpdate[rt.code] ?? 0}
                              onChange={(e) => handleRewardChange(e, group, rt)}
                              placeholder={t(
                                "commission_step_reward_placeholder",
                              )}
                              onClick={(e) => e.target.select()}
                            />
                          </div>
                          <div className="flex items-center gap-1">
                            <label className="text-[11px] text-slate-500 w-[70px] text-left shrink-0">
                              {t("member_commission_label")}
                            </label>
                            <input
                              type="number"
                              min="0"
                              max="100"
                              disabled={fieldDisabled}
                              className="w-full font-bold text-[12px] border-[1px] border-slate-300 rounded-lg text-center disabled:bg-slate-100 disabled:text-slate-400"
                              name={rt.code}
                              value={commission[rt.code] ?? 0}
                              onChange={(e) =>
                                handleCommissionChange(e, group, rt)
                              }
                              placeholder={t(
                                "commission_step_commission_placeholder",
                              )}
                              onClick={(e) => e.target.select()}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default Step1;
